import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import css from './css/common.css'

Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  css,
  render: h => h(App)
}).$mount('#app')
